angular.module('galilai.creator').factory('parserService', function(styleService, videoService) {

    const ENABLE_ROTATION = false
    const MAP_REPLACE_VALUES = {
        'main_image': 'image'
    }

    const customSettingsAttributes = [
        'titleSize',
        'titleMinSize',
        'titleAlign',
        'descriptionSize',
        'descriptionMinSize',
        'descriptionAlign',
        'visual',
        'hideOverlay',
    ]
    function generateRandomHash(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let hash = '';
        for (let i = 0; i < length; i++) {
          hash += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return hash;
    }

    function generateLayoutId() {
        return generateRandomHash(16)
    }

    const DEFAULT_THEME = getBaseTheme()

    function fixTheme(theme) {
        // Check for default size
        if (!theme.size) {
            theme.size = Object.assign({}, DEFAULT_THEME.size)
        }
        if (!theme.defaults) {
            theme.defaults = Object.assign({}, DEFAULT_THEME.defaults)
        }
        if (!theme.pallete) {
            theme.pallete = Object.assign({}, DEFAULT_THEME.pallete)
        }
        if (!theme.fonts) {
            theme.fonts = Object.assign({}, DEFAULT_THEME.fonts)
        }
        return theme
    }
    function colorPermutations(newTheme, existingTheme, variation) {
        const permutations = [
            ['main', 'text', 'highlight'],
            ['text', 'main', 'highlight'],
            ['highlight', 'main', 'text'],
            ['main', 'highlight', 'text'],
            ['text', 'highlight', 'main'],
            ['highlight', 'text', 'main'],
        ]
        let current = permutations[variation]
        newTheme.pallete.main = existingTheme.pallete[current[0]]
        newTheme.pallete.text = existingTheme.pallete[current[1]]
        newTheme.pallete.highlight = existingTheme.pallete[current[2]]
    }

    function getThemeForItem(theme, item, index) {
        if (theme.settings && theme.settings[index]) {
            let newTheme = JSON.parse(JSON.stringify(theme))
            newTheme.custom = {}

            // Apply custom pallete
            if (newTheme.settings[index].pallete && ['main', 'text', 'highlight'].every(function(key) {
                return newTheme.settings[index].pallete[key]
            })) {
                newTheme.pallete = newTheme.settings[index].pallete
            }

            if (theme.settings[index].invertColor) {
                let currentTheme = JSON.parse(JSON.stringify(newTheme))
                // TODO - Allow more variations
                colorPermutations(newTheme, currentTheme, 1)
            }
            if (typeof theme.settings[index].autoFontSize == 'undefined' || theme.settings[index].autoFontSize === true) {
                newTheme.custom.autoFontSize = true
            } else {
                newTheme.custom.autoFontSize = false
            }
            customSettingsAttributes.map(function(attr) {
                if (theme.settings[index][attr]) {
                    newTheme.custom[attr] = theme.settings[index][attr]
                }
            })
            newTheme = fixTheme(newTheme)
            return newTheme
        }
        theme = fixTheme(theme)
        return theme
    }

    function getUniqueId(globalParams, element) {
        if (!globalParams['ids']) {
            globalParams['ids'] = {}
        }
        if (typeof globalParams.ids[element.type] == 'undefined') {
            globalParams.ids[element.type] = 0
        }
        globalParams.ids[element.type] ++
        return element.type + '-' + globalParams.ids[element.type]
    }

    function adjustColor(inputHSL, targetHSL) {
        const [h1, s1, l1] = inputHSL.map(Number);
        const [h2, s2, l2] = targetHSL.map(Number);

        // Hue rotation
        let hueRotate = h2 - h1;
        hueRotate = (hueRotate + 360) % 360;  // ensure it's within 0-360 degrees

        // Saturation adjustment (more complex because we need to adjust the scale factor)
        let saturationPercent = 100 + (s2 - s1);
        if (saturationPercent <= 0) saturationPercent = 0.01;  // saturation cannot be zero in CSS

        // Lightness adjustment
        let lightnessPercent = 100 * (l2 / l1);
        if (lightnessPercent <= 0) lightnessPercent = 0.01;

        // Attempt to calculate contrast (this is quite heuristic and might not be very accurate)
        let contrastFactor = 100 * (s2 / s1);
        if (contrastFactor < 100) contrastFactor = 100;

        // Assembling the filter string
        return {
            hue: hueRotate,
            saturate: saturationPercent/100,
            brightness: lightnessPercent/100, // Not being used
            contrast: contrastFactor/100, // Not being used
        }
    }


    function calculateColorTransformation(extras) {
        if (!extras || !extras.originalLayout || !extras.originalLayout.pallete || !extras.originalLayout.pallete.main) {
            return
        }
        let mainColorHSL = HEXtoHSL(extras.pallete.main)
        mainColorHSL = {
            h: mainColorHSL[0],
            s: mainColorHSL[1],
            l: mainColorHSL[2]
        }

        let layoutColorHSL = HEXtoHSL(extras.originalLayout.pallete.main)
        layoutColorHSL = {
            h: layoutColorHSL[0],
            s: layoutColorHSL[1],
            l: layoutColorHSL[2]
        }
        let info = adjustColor([layoutColorHSL.h, layoutColorHSL.s, layoutColorHSL.l], [mainColorHSL.h, mainColorHSL.s, mainColorHSL.l])
        return info
    }

    function splitItemValues(itemConfig) {
        if (!itemConfig) {
            return
        }
        if (itemConfig.price) {
            let parsed = splitPrice(itemConfig.price)
            if (parsed) {
                itemConfig.price = parsed
            }
        }

        if (itemConfig.discount) {
            let discount = splitDiscount(itemConfig.discount)
            if (discount) {
                itemConfig.discount = discount
            }
        }
    }

    function splitDiscount(text) {
        // Need to have % and number
        if (!text || text.indexOf('%') == -1) {
            return null
        }
        const regex = /(\d+%)/;
        if (!regex.test(text)) {
            return null
        }
        const parts = text.split(regex);

        // Without %
        let numericPart = parts[1].replace('%', '')
        let afterPart = parts[2]?.trim()
        // Check if after contains OFF if contains add to right and remove from after
        let rightPart = '%'
        // TODO - Improve this
        if (afterPart && afterPart.trim().startsWith('OFF')) {
            rightPart = '%\nOFF'
            afterPart = afterPart.replace('OFF', '').trim()
        }
        let result = {
            before: parts[0]?.trim(),
            number: {
                main: numericPart,
                right: rightPart,
            },
            after: afterPart,
        };
        return result
    }

    function getAllElementsWithReplace(layout) {
        if (!layout || !layout.elements) {
            return []
        }
        let elements = []
        layout.elements.forEach(function(element) {
            if (element.replace) {
                elements.push(element)
            }
            if (element.elements && element.elements.length > 0) {
                elements = elements.concat(getAllElementsWithReplace(element))
            }
        })
        return elements
    }

    function convertLayout(layout, itemConfig, extras, globalParams={}) {
        if (!layout) {
            return null
        }
        let mainId = null
        let isTopLevelContainer = false
        layout = JSON.parse(JSON.stringify(layout))
        extras = JSON.parse(JSON.stringify(extras))
        itemConfig = JSON.parse(JSON.stringify(itemConfig))

        if (!globalParams.renderedId) {
            try {
                splitItemValues(itemConfig)
            } catch (e) {
                console.log('Error splitting values', e)
            }
        }

        if (!layout) {
            return null
        }
        // Override with brand kit
        let shouldApplyRotation = extras.global && extras.global.applyRotation
        if (!layout.brandKit && extras.global && extras.global.brandKit && !shouldApplyRotation) {
            let brandKit = JSON.parse(JSON.stringify(extras.global.brandKit))
            if (brandKit.colors && brandKit.colors.main && brandKit.colors.highlight && brandKit.colors.text) {
                extras.pallete.main = brandKit.colors.main
                extras.pallete.text = brandKit.colors.text
                extras.pallete.highlight = brandKit.colors.highlight
            }
            delete extras.global.brandKit
        }

        if (layout.classification) {
            extras.classification = layout.classification
        }

        let enabledRotation = ENABLE_ROTATION && extras && extras.global && extras.global.applyRotation
        if (layout.pallete && enabledRotation) {
            if (!extras) {
                extras = {}
            }
            if (!extras.originalLayout) {
                extras.originalLayout = {}
            }
            extras.originalLayout.pallete = layout.pallete
            extras.originalLayout.transformation = calculateColorTransformation(extras)
            delete layout.pallete
        }
        let applyUserBrandKit = extras && extras.global && extras.global.applyRotation
        if (layout.brandKit) {
            extras.brandKit = layout.brandKit
            // Override all brand kit from selected layout
            if (extras.brandKit && extras.brandKit.colors && extras.brandKit.colors.highlight && !applyUserBrandKit) {
                extras.pallete.highlight = extras.brandKit.colors.highlight
            }
            delete layout.brandKit
        }

        if (globalParams && globalParams.mainId) {
            mainId = globalParams.mainId
            delete globalParams.mainId
        }
        if (!globalParams) {
            globalParams = {}
        }
        if (!globalParams.renderedId) {
            globalParams.renderedId = generateLayoutId()
            isTopLevelContainer = true
            let elementsToReplace = getAllElementsWithReplace(layout)
            let elementsColors = {}
            // Now map replace to color
            if (elementsToReplace && elementsToReplace.length > 0) {
                elementsToReplace.map(function(element) {
                    if (element.replace && element.color) {
                        elementsColors[element.replace] = element.color
                    }
                })
                extras.elementsColors = elementsColors
            }
        }
        extras.renderedId = globalParams.renderedId

        if (!layout) {
            return null
        }
        if (layout.invert) {
            let mainColor = extras.pallete.main
            extras.pallete.main = extras.pallete.text
            extras.pallete.text = mainColor
        }
        if (layout.meta) {
            if (layout.meta.overlay && extras && extras.pallete && itemConfig.image) {
                extras.pallete = improvePallete(extras.pallete, type='dark')
            }
            else if (layout.meta.whitebg && extras && extras.pallete) {
                extras.pallete = improvePallete(extras.pallete, type='white')
            }

            if (layout.meta.number_highlight && itemConfig.title) {
                itemConfig.title = itemConfig.title.replace('font-size:6rem;', `font-size:${layout.meta.number_highlight}rem;`)
                itemConfig.title = itemConfig.title.replace('display:block;', `display:inline-block;`)
            }

            // TASK [HP] Allow to have highlight in the future for some layouts
            if (typeof layout.meta.text_highlight != 'undefined' && !layout.meta.text_highlight) {
                let title = itemConfig.title
                title = title.replace(/<em[^>]*class="number-highlight"[^>]*>(.*?)<\/em>/g, '')
                title = title.replace(/<em[^>]*>(.*?)<\/em>/g, '$1')
                title = title.stripHtml()
                itemConfig.title = title
            }
        }

        // Check list parser
        if (itemConfig.description && itemConfig.description.indexOf('✓') != -1) {
            itemConfig.description = itemConfig.description.replaceAll('✓', `<i style="color:${extras.pallete.highlight}" class="mdi mdi-checkbox-marked-circle"></i>`)
        }

        extras.info = {}
        // Extra info
        let hasTitle = itemConfig && itemConfig.title && itemConfig.title.trim() != ''
        let hasDescription = itemConfig && itemConfig.description && itemConfig.description.trim() != ''
        if (!hasTitle && hasDescription) {
            extras.info.descriptionOnly = true
        }
        let elements = [];
        if (layout.id == 'main') {
            try {
                if (itemConfig.overlays && itemConfig.overlays.elements && itemConfig.overlays.elements.length > 0) {

                    // Remove overlays without visual style
                    itemConfig.overlays.elements = itemConfig.overlays.elements.filter(function(element) {
                        return extras && extras.custom && extras.custom.visual && extras.custom.visual.elements && extras.custom.visual.elements[element.uniqueId]
                    })
                    // sort itemConfig.overlays.elements by having ids that start with background- first
                    itemConfig.overlays.elements = itemConfig.overlays.elements.sort(function(a, b) {
                        if (a.id && a.id.indexOf('background-') == 0) {
                            return 1
                        }
                        return -1
                    })

                    let newElements = layout.elements.slice(0, 1)
                    itemConfig.overlays.elements.map(function(element) {
                        newElements.push(element)
                    })
                    for (let i = 1; i < layout.elements.length; i++) {
                        newElements.push(layout.elements[i])
                    }
                    layout.elements = newElements
                }
            } catch (e) {
                logError({
                    message: 'Error sorting overlays',
                    error: e
                })
            }
        }
        for (let i = 0; i < layout.elements.length; i++) {
            let element = JSON.parse(JSON.stringify(layout.elements[i]));

            let newElement = {
                visible: true,
                type: element.type,
            }
            let uniqueId = element.uniqueId || getUniqueId(globalParams, newElement)
            // LATER - hardcoded
            if (element.type == 'icon') {
                // LATER - Improve
                if (itemConfig.icons && itemConfig.icons.length > 0) {
                    element.src = itemConfig.icons[0]
                }
            }
            try {
                let hasWatermark = element.replace == 'author.handle' && itemConfig && itemConfig.author && itemConfig.author.logo && itemConfig.author.logo.enabled && (typeof element.watermark == 'undefined' || element.watermark)

                if (element.replace) {
                    if (typeof MAP_REPLACE_VALUES[element.replace] != 'undefined') {
                        if (extras && extras.classification && extras.classification.area == 'generic' && element.replace == 'main_image' && element.src) {
                            delete element.src
                        }
                        element.replace = MAP_REPLACE_VALUES[element.replace]
                    }
                    let path = element.replace.split('.')
                    let value = itemConfig
                    for (let i = 0; i < path.length; i++) {
                        if (typeof value == 'undefined' || value == null) {
                            value = null
                            break
                        }
                        if (typeof value[path[i]] == 'undefined') {
                            value = null
                            break
                        }
                        value = value[path[i]]
                    }
                    if (value == null && element.preview) {
                        value = element.preview
                    }
                    if (value && element.type == 'image') {
                        element.src = value

                        if (value.full && globalParams.video) {
                            element.type = 'video'
                            newElement.type = 'video'
                            newElement.src = videoService.getCachedVideo(value[globalParams.video.size] || value.small)
                        } else if (value.full) {
                            element.src = value.thumb
                            newElement.video = true
                        }
                    } else {
                        newElement.value = value
                        element.replacedValue = value
                    }
                    if (element.replace == 'number' && value && typeof value != 'undefined' && value.trim && value.trim() != '') {
                        globalParams.hasNumber = true
                    }

                    if (element.replace == 'author.handle' && hasWatermark) {
                        // TASK [HP] - Improve make more generic
                        let url = itemConfig.author.logo.url
                        element.replace
                        element.src = url
                        element.type = 'image'
                        element.replacedValue = url
                        newElement.type = 'image'
                        newElement.value = url
                    }
                }

                newElement.style = styleService.generate(element, i, extras, uniqueId)

                // Additional attrs
                if (element.computed && element.computed.viewBox) {
                    if (!newElement.attrs) {
                        newElement.attrs = {}
                    }
                    newElement.attrs.viewBox = element.computed.viewBox
                }

                // Color watermark system
                if (element.replace == 'author.handle' && hasWatermark) {
                    // Only apply size if not defined
                    if (!newElement.style.width || !newElement.style.height) {
                        newElement.style.width = element.width || '80px'
                        let sizeLogoMap = {
                            'extrasmall': '15px',
                            'small': '20px',
                            'medium': '30px',
                            'large': '40px',
                            'extralarge': '80px',
                        }
                        if (itemConfig.author.logo.size == 'large') {
                            newElement.style.width = '100px'
                        }
                        if (itemConfig.author.logo.size == 'extralarge') {
                            newElement.style.width = '135px'
                        }
                        newElement.style.height = sizeLogoMap[itemConfig.author.logo.size] || '20px'
                    }

                    newElement.style['background-size'] = 'contain'
                    newElement.style['background-repeat'] = 'no-repeat'
                    newElement.style['background-position'] = element.align || 'inherit'
                    let backgroundMode = itemConfig.author.logo.mode
                    if (backgroundMode == 'watermark') {
                        try {
                            let watermarkColor = extras.pallete.text
                            if (element.color) {
                                watermarkColor = styleService.replaceColor(element.color, extras.pallete)
                            }
                            let {red, green, blue} = hexToRgb(watermarkColor)
                            let solution = new Solver(new Color(red, green, blue)).solve()
                            let filter = solution.filter.replace('filter: ', '').replace(';', '')
                            newElement.style['filter'] = filter
                        } catch (e) {
                            console.log('Error filter', e)
                        }
                        if (typeof newElement.style['opacity'] == 'undefined') {
                            newElement.style['opacity'] = '0.6'
                        }
                    } else {
                        if (typeof newElement.style['opacity'] == 'undefined') {
                            newElement.style['opacity'] = '1'
                        }
                    }
                }
            } catch (e) {
                logError({
                    message: 'Error parsing element',
                    error: e
                })
            }

            // TODO - make this more generic
            let requiredFields = [
                'title',
                'description',
            ]
            const showOriginalText = extras && extras.global && extras.global.showOriginalText

            if (element.value && !newElement.value) {
                if (requiredFields.indexOf(element.replace) == -1 || showOriginalText) {
                    newElement.value = element.value;
                }
            }
            if (element.type == 'overlay') {
                newElement.value = styleService.applyPropertiesToValue(element, extras)
            }
            if (element.type == 'container' && element.elements) {
                newElement.elements = convertLayout(element, itemConfig, extras, globalParams).elements;
            }
            if (element.type == 'fa') {
                newElement.class = element.value
            }
            if (typeof element.visible == 'boolean') {
                newElement.visible = element.visible;
            }
            if (element.type == 'image' || element.type == 'icon') {
                if (!newElement.style || (newElement.style && !newElement.style.width)) {
                    newElement.visible = false;
                }
                if (!element.src && !element.content) {
                    newElement.visible = false;
                }
                if (element.content) {
                    newElement.content = element.content
                }
            }
            // Replace SVGs colors
            if (newElement.value) {
                newElement.value = styleService.highlightText(newElement.value, extras);
            }
            if (element.required && !newElement.value) {
                newElement.visible = false;
            }
            newElement.id = uniqueId
            if (element.area) {
                newElement.area = element.area
            }
            if (element.id) {
                newElement.originalId = element.id
            }
            if (element.type == 'clipPath') {
                newElement.id = `${globalParams.renderedId}-${element.id}`
                newElement.path = element.path

                if (element.clipPathUnits) {
                    if (!newElement.attrs) {
                        newElement.attrs = {}
                    }
                    newElement.attrs.clipPathUnits = element.clipPathUnits
                }
            }
            if (!newElement.attrs) {
                newElement.attrs = {}
            }
            if (element.draggable || (typeof element.draggable == 'undefined' && element.type != 'container')) {
                newElement.attrs['data-drag'] = 'true'
            }
            elements.push(newElement);
        }

        let classes = {
            'has-number': globalParams.hasNumber,
        }
        let container = {
            label: layout.label,
            type: 'container',
            size: extras && extras.size && extras.size.id ? extras.size.id : 'portrait',
            categories: layout.categories,
            tags: layout.tags,
            elements: elements.filter(function(element) {
                return element.visible;
            }),
            classes: classes,
            style: styleService.generate(layout, 0, extras)
        }
        if (mainId) {
            container.id = mainId
        }
        if (isTopLevelContainer) {
            container.renderId = globalParams.renderedId
        }
        return container
    }

    function _getContentForItem(item, itemConfig, index) {
        let base = {}
        if (itemConfig && itemConfig.global && itemConfig.global.content) {
            base = Object.assign({}, itemConfig.global.content)
        }
        item = Object.assign(JSON.parse(JSON.stringify(base)), item)
        if (itemConfig.images && itemConfig.images.hasOwnProperty(index)) {
            item.image = itemConfig.images[index]
        } else if (!(item.image && item.image.indexOf('.gif'))) { // TASK [HP] Improve
            item.image = null
        }
        if (itemConfig.icons && itemConfig.icons.hasOwnProperty(index)) {
            item.icons = itemConfig.icons[index]
        }
        // TODO - Overlay issues
        /*
        if (itemConfig.overlays && itemConfig.overlays.hasOwnProperty(index)) {
            item.overlays = itemConfig.overlays[index]
        }*/
        return item
    }

    function _getThemeForItem(itemTheme, item, index, post) {
        itemTheme = JSON.parse(JSON.stringify(itemTheme))
        // Assign global theme configs
        if (post && post.data && post.data.theme && post.data.theme.global ) {
            itemTheme.global = Object.assign({}, post.data.theme.global)
        }
        if (!itemTheme.global) {
            itemTheme.global = {}
        }
        if (typeof itemTheme.global.applyRotation == 'undefined') {
            itemTheme.global.applyRotation = true
        }
        return getThemeForItem(itemTheme, item, index)
    }

    function getFullParsed(post, index) {
        post.data.items[index].global = Object.assign({}, post.data.items[index].global, post.data.global)

        return convertLayout(
            post.data.layouts[index], // TODO - Load from cache
            _getContentForItem(post.data.items[index], post.data, index),
            _getThemeForItem(post.data.theme, post.data.items[index], index, post),
        );
    }

    return {
        convertLayout: convertLayout,
        getThemeForItem: getThemeForItem,
        getFullParsed: getFullParsed,
    }
});
